import type { ConsistencyAlert } from './types';

/**
 * ConsistencyAlerts — affiche les warnings de `RatingsAggregator::snapshot.consistency_check`.
 *
 * Seuil 200 ELO côté backend (RATINGS_CONSISTENCY_THRESHOLD). Détecte les
 * incohérences cross-platform (FIDE Rapide très bas vs Lichess Rapid → possible
 * décalage temporel ou erreur de saisie).
 */

const SEVERITY_TONE: Record<
  ConsistencyAlert['severity'],
  { border: string; text: string; chip: string }
> = {
  info: {
    border: 'border-cyan-500/30',
    text: 'text-cyan-500',
    chip: 'bg-cyan-500/10',
  },
  warning: {
    border: 'border-amber-500/30',
    text: 'text-amber-500',
    chip: 'bg-amber-500/10',
  },
  critical: {
    border: 'border-coral-500/30',
    text: 'text-coral-500',
    chip: 'bg-coral-500/10',
  },
};

export function ConsistencyAlerts({ alerts }: { alerts: ConsistencyAlert[] }): JSX.Element | null {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 mb-4">
      {alerts.map((a, i) => {
        const tone = SEVERITY_TONE[a.severity];
        return (
          <div
            key={i}
            role="alert"
            className={`rounded-lg border ${tone.border} ${tone.chip} px-3 py-2 flex items-start gap-3`}
          >
            <span
              className={`text-[10px] font-mono uppercase tracking-widest ${tone.text}`}
            >
              {a.severity}
            </span>
            <span className="text-paper-50 text-body-sm">{a.message}</span>
          </div>
        );
      })}
    </div>
  );
}
